import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const StoreContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StoreProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token && user) {
      fetchStores();
    }
  }, [token, user]);

  const fetchStores = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/stores`);
      setStores(response.data);
      if (response.data.length > 0 && !selectedStore) {
        setSelectedStore(response.data[0]);
      }
    } catch (error) {
      console.error('Failed to fetch stores:', error);
    } finally {
      setLoading(false);
    }
  };

  const createStore = async (storeData) => {
    const response = await axios.post(`${API}/stores`, storeData);
    await fetchStores();
    return response.data;
  };

  const updateStore = async (storeId, storeData) => {
    const response = await axios.put(`${API}/stores/${storeId}`, storeData);
    await fetchStores();
    return response.data;
  };

  const deleteStore = async (storeId) => {
    await axios.delete(`${API}/stores/${storeId}`);
    await fetchStores();
  };

  const getStore = async (storeId) => {
    const response = await axios.get(`${API}/stores/${storeId}`);
    return response.data;
  };

  return (
    <StoreContext.Provider value={{
      stores,
      selectedStore,
      setSelectedStore,
      loading,
      fetchStores,
      createStore,
      updateStore,
      deleteStore,
      getStore
    }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};

export default StoreContext;
